export const configMap = {
  // 开发
  development: {
    rootPath: 'https://api-dev2.hoby.chat',
    realEnv: 'development',
    host: 'https://web-hy-dev.hoby.live',
    hobyWebHost: 'https://web-react-dev.hoby.live', // 旧项目host地址
  },
  // 测试
  testing: {
    rootPath: 'https://api-web.hoby.chat',
    realEnv: 'testing',
    host: 'https://web-hy-test.hoby.live',
    hobyWebHost: 'https://web-react-test.hoby.live', // 旧项目host地址
  },
  // 灰度
  uat: {
    rootPath: 'https://api-gray2.thechatie.com',
    realEnv: 'testing',
    host: 'https://web-hy-uat.hoby.live',
    hobyWebHost: 'https://web-react-uat.hoby.live', // 旧项目host地址
  },
  production: {
    rootPath: 'https://api-web.hoby.chat',
    realEnv: 'production',
    host: 'https://web-hy.hoby.chat',
    hobyWebHost: 'https://web-react.hoby.live', // 旧项目host地址
  },
};

type Environment = 'development' | 'testing' | 'uat' | 'production';
const NODE_ENV: Environment = import.meta.env.MODE as Environment;

export function getConfig(env?: 'development' | 'testing' | 'uat' | 'production') {
  const config = configMap[env || NODE_ENV] || configMap['production'];
  const defaultConfig = {
    language: 'en',
    designWidth: 375,
    projectName: 'hybrid',
    contactServiceTel: '+1(332)276-3365',
  };

  return Object.assign(defaultConfig, config);
}
